// extracted by mini-css-extract-plugin
export default {"basemap-editor":"basemap-editor","container-body":"container-body","geography-form-container":"geography-form-container","sidebar-container":"sidebar-container"};